import { isFuture, isPast, secondsToMilliseconds } from 'date-fns';

import { RBLink, SearchLink } from 'store/railsBuilder/reducer.types';

export default function isValidDeeplinkItem(
    link: RBLink | SearchLink | undefined,
) {
    if (!link) {
        return false;
    }

    return (
        isPast(secondsToMilliseconds(link.period.start)) &&
        isFuture(secondsToMilliseconds(link.period.end))
    );
}
